import axios, { AxiosRequestConfig } from "axios";
import URL from "../utils/urls";
import CONSTANTS from "./../utils/constants";
import { CodatCompanyRes, CompanyRes } from "../stores/company/company-state";
import {isEmpty} from "../utils/common-utils";


export async function getUserPortfolioTeamCodes() {
  const { data } = await axios.get(URL.bff.UserPortfolioTeamCodes);

  return data?.results?.[0] || {};
}

export async function saveUserPortfolioDetails(payload) {
  const { data } = await axios.post(URL.bff.UserPortfolioTeamCodes, payload);

  return data;
}

export  async function getCashAccountsData(companyId, cif, reportingMonth) {
    const { data } = await axios.post(
        URL.bff.getCashAccountsData,
        {companyId, cif, reportingMonth}
    );

    return data;
}

export async function getLoanAccountsData(companyId: string, cif: string, reportingMonth: string) {
  const { data } = await axios.post(URL.bff.getLoanAccountsData, { companyId, cif, reportingMonth });

  return data;
}

export  async function saveCashAccountsMapping(payload) {
    const { data } = await axios.post(URL.bff.saveCashAccountsMapping, payload); 
    return data;
}

export  async function getReportsList() {
    const { data } = await axios.get(URL.bff.getReportsList); 
    return data;
}

export  async function getDownloadReportFile(id: string) {
    const { data } = await axios.get(URL.bff.getDownloadReport(id)); 
    return data;
}
export async function saveLoanAccountMapping(payload: {
  codatCompanyId: string;
  cif: string;
  reportingMonth: string;
  nextReportingMonth: string; // "YYYY-MM-DD"
  data: any;
}): Promise<any> {
  const { data } = await axios.post(URL.bff.saveLoanAccountsMapping, payload);
  return data;
}

export async function getUserEntitiesNJourneys() {
    const { data } = await axios.get(
        URL.bff.getUserEntitiesNJourneys
    );

    return data;
}

export async function getUserJourneyTasks(journeyId) {
    const { data } = await axios.get(
        URL.bff.getUserJourneyTasks(journeyId)
    );

    return data;
}

export async function verifyEntity(entityId: string) {
    const { data } = await axios.put(
        URL.bff.verifyEntity(entityId)
    );

    return data;
}

export async function uploadDocument(request: FormData) {
    const { data } = await axios.post(
        URL.bff.uploadDocument,
        request,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    return data;
}

export async function updateIdvStatus(entityId: string, draftId: string, formData: FormData) {
    const { data } = await axios.post(
        URL.bff.updateIdvStatus(entityId, draftId),
        formData
    );

    return data;
}
export async function submitApplicationData(formData: any) {
    const { data } = await axios.post(
        URL.bff.submitApplication,
        formData
    );

    return data;
}

export async function updateProspectIdvDocs(entityId: string, formData: FormData) {
    const { data } = await axios.post(
        URL.bff.updateProspectIdvDocs(entityId),
        formData
    );

    return data;
}

export async function verifyIndividual(formData: any, entityId: string, entityDraftId: string) {
    const { data } = await axios.put(
        URL.bff.verifyIndividual(entityId, entityDraftId),
        formData
    ); 
    return data;
}

export async function getDocusignRecipientStatus(entityDraftSourceEntityId: string, email: string) {
  let payload = {
    email: email,
  }
  const response = await axios.post(
    URL.bff.getDocusignRecipientStatus(entityDraftSourceEntityId),
    payload
  );
  return response.data
}

export async function getDocusignRecipientViewURL(formData: any ) {
  const response = await axios.post(
    URL.bff.getDocusignRecipientViewURL,
    formData
  );
  return response.data
}

export async function triggerInvite(formData: any) {
    const response = await axios.post(
        URL.bff.triggerInvite,
        {
            company_info: {
                applicant_type: "Company",
                dba_name: formData.companyName,
                isNewCompany: (formData.isNextCompany || formData.isNewCompany) ?? false,
                lendx_company_id: formData.companyId
            },
            user_info: {
                name: {
                    given_name: formData.firstName,
                    last_name: formData.lastName,
                    preferred_name: formData.firstName
                },
                contact_information: {
                    email: formData.email,
                    phone_number: {
                        country_code: "+1",
                        primary: true,
                        number: formData.mobileNumber,
                        type: "MOBILE"
                    }
                }
            }
        }
    );
    return response.data
}
export async function triggerPortalInvite(formData: any) {
    const response = await axios.post(
        URL.bff.triggerPortalInvite,
        {
            company_info: {
                applicant_type: "Company",
                dba_name: formData.companyName,
                lendx_company_id: formData.companyId
            },
            user_info: {
                name: {
                    given_name: formData.firstName,
                    last_name: formData.lastName,
                    preferred_name: formData.firstName
                },
                contact_information: {
                    email: formData.email,
                    phone_number: {
                        country_code: "+1",
                        primary: true,
                        number: formData.mobileNumber,
                        type: "MOBILE"
                    }
                }
            },
            action: 'ADF'
        }
    );
    return response.data
}
export async function getUserInfo() {
    const { data } = await axios.get(URL.bff.getUserInfo);
    return data;
}

export async function submitI2CData(formData: any ) {
    const response = await axios.post(
      URL.bff.I2CUpdate,
      formData
    );
    return response.data
  }

export async function getDataGroups() {
    const { data } = await axios.get(URL.bff.dataGroups);
    return data;
}

export async function inviteCollaborator(formData: any ) {
    const response = await axios.post(
      URL.bff.inviteCollaborator,
      formData
    );
    return response.data
  }

export async function fetchCollaborators(journeyId: string) {
    const response = await axios.get(
        URL.bff.fetchCollaborators(journeyId)
    );
    return response.data
}

export async function deleteCollaborator(associationId: any, journeyId: string) {
    const response = await axios.delete(
        URL.bff.deleteCollaborator(associationId, journeyId),
    );
    return response.data;
}

export async function getCompanies(config: any): Promise<CompanyRes> {
    let url: string;
    if(isEmpty(config.query)) {
        url = URL.bff.getCompanies
    } else {
        url = URL.bff.getCompaniesWithQuerySearch(config?.query);
    }
    const response = await axios.get(url, { signal: config.signal });
    return response.data;
}

export async function getWatchlistCompanies(config: any): Promise<CompanyRes> {
    const response = await axios.get(URL.bff.getWatchlistCompanies, config);
    return response.data;
}

export async function getCompanyDetails(companyId:any) {
    const response = await axios.get(
        URL.bff.getCompanyDetails(companyId)
    );
    return response.data
}

export async function editPersonalDetails(details: any) {
     const response = await axios.put(
        URL.bff.updatePersonalDetails,
        details
     );
     return response.data;
}

export const addCompanyDetails = async (companyDetails: any) => {
    const response = await axios.post(
        URL.bff.addCompanyDetails,
        companyDetails
    );
    return response.data
}

export async function updateCompanyDetails(companyDetails: any) {
    const response = await axios.put(
        URL.bff.updateCompanyDetails,
        companyDetails
    );
    return response.data
}

export async function getWorkbookRecords(companyId: string, signal: AbortSignal) {
    const response = await axios.get(
        URL.bff.getWorkbookRecords(companyId), { signal }
    );
    
    return response.data;
}

export async function getTimelineRecords(companyId: string, signal: AbortSignal) {
    const response = await axios.get(
        URL.bff.getTimelineRecords(companyId), 
        { signal: signal }
    );
    return response.data;
}

export async function downloadWorkbook(bucket: string, key: string) {
    const response = await axios.get(
        URL.bff.downloadWorkbook(bucket, key)
    );
    return response.data;
}
export async function toggleCompanyHiddenStatus(payload: any) {
    const response = await axios.put(
      URL.bff.toggleCompanyHiddenStatus,
      payload
    );
    return response.data;
}
export async function fireWorkbookRefresh(payload:any) {

    const response = await axios.post(
        URL.bff.fireWorkbookRefresh,payload
    );
    return response
}

export async function sendWorkbookToExternalSystem(payload: any) {
    const response = await axios.post(
        URL.bff.sendWorkbookToExternalSystem, payload
    );
    return response.data
}

export async function getAccountMappings(companyId:any) {
    const response = await axios.get(
        URL.bff.getAccountMappings(companyId)
    );
    return response.data
}

export async function updateBorrowerAccountMappingsForRefresh(payload:any) {
    const response = await axios.post(
        URL.bff.updateBorrowerAccountMappingsForRefresh,payload
    );
    return response.data
}

export async function saveBucketing(payload:any) {
    const response = await axios.put(
        URL.bff.saveBucketing,payload
    );
    return response.data
}

export async function getAllSvbers() {
    const response = await axios.get(
        URL.bff.allSvbers
    );
    return response.data
}

export async function addDashboardUsers(payload: any) {
    const response = await axios.post(
        URL.bff.addDashboardUsers, payload
    );
    return response.data
}

export async function updateUserByEmail(payload: any) {
    const response = await axios.put(
        URL.bff.updateUserByEmail, payload
    );
    return response.data
}

export async function notifyPrimarySVBContact(payload: any) {
  const response = await axios.post(URL.bff.notifyPrimaryContact, payload);
  return response.data;
}
export async function reNotifyCSContact(payload: any) {
  const response = await axios.post(URL.bff.reNotifyCSContact, payload);
  return response.data;
}
export async function updateDepositAccountsMappingStatus(payload) {
    const { data } = await axios.put(URL.bff.updateDepositAccountsMappingStatus, payload);
    return data;
}

export  async function getRestatementSummary(companyId: string) {
    const { data } = await axios.get(URL.bff.getRestatementSummary(companyId));
    return data;
}

export async function getRestatementSummaryPFSAndPL(companyId: string) {
    const { data } = await axios.get(URL.bff.getRestatementSummaryPFSAndPL(companyId));
    return data;
}

export async function updateLoanAccountsMappingStatus(payload: {
  codatCompanyId: string;
  cif: string;
  reportingDate: string;
  status: string;
}): Promise<any> {
  const { data } = await axios.put(URL.bff.updateLoanAccountsMappingStatus, payload);
  return data;
}

export async function getBookClosureCompanies(config: any) {
  const response = await axios.get(URL.bff.getBookClosureCompanies, config);
  return response.data;
}

export async function getActionRequiredCompanies() {
  const response = await axios.get(URL.bff.getActionRequiredCompanies);
  return response.data;
}

export async function getActionedCompanies() {
  const response = await axios.get(URL.bff.getActionedCompanies);
  return response.data;
}

export async function updateDisconnectMgmtStatus(payload: any) {
    const response = await axios.put(
        URL.bff.updateDisconnectMgmtStatus, payload
    );
    return response.data
}

export async function getRestatementStatus(payload: any) {
     const response = await axios.post(
        URL.bff.getRestatementStatus, payload
    );
    return response.data
}

export async function getPdsEligibilityStatus(payload: {
  cif: string;
  legal_entity_name: string;
  crm_entity_id: string;
}): Promise<any> {
  const { data } = await axios.post(URL.bff.getPdsEligibility, payload);
  return data;
}

export async function getCreditlensCategoryRollup() {
    const response = await axios.get(URL.bff.getCreditlensCategoryRollup);
    return response.data;
}